import SurveyQuestionResponses from '../models/Survey/SurveyQuestionResponses';
import SurveyResponse from '../models/Survey/SurveyResponse';
import BaseAPIClient from './base/BaseAPIClient';

export default class SurveyClient extends BaseAPIClient {

    _200SurveyResponse(response) {
        return new SurveyResponse(response)
    }
    _404Null(error) {
        if(error.status === 404)
            return null;
        throw error
    }

    submitSurvey(response_id) {
        return this._post('surveys/responses/submit', { 
            external_id: response_id, 
        })
    }

    respondToMultipleChoiceQuestion(response_id, question_slug, response) {
        return this._post('surveys/responses/answer', { 
            external_id: response_id, 
            question_slug, 
            selections: response ? response.selections : [],
            follow_up: response ? response.follow_up : ''
        })
    }
    respondToFreeTextQuestion(response_id, question_slug, response) {
        return this._post('surveys/responses/answer', { 
            external_id: response_id, 
            question_slug, 
            free_text: response
        })
    }
    respondToStarRatingQuestion(response_id, question_slug, response) {
        return this._post('surveys/responses/answer', { 
            external_id: response_id, 
            question_slug, 
            star_rating: response
        })
    }
    createResponse(user_id, slug) {
        return this._post('surveys/responses/create', { user_id, slug })
            .then(this._200SurveyResponse, this._404Null)
    }
    getLatestResponseFromSlug(user_id, slug) {
        return this._get('surveys/responses', { user_id, slug })
            .then(this._200SurveyResponse, this._404Null)
    }
    getResponseForAnonymous(external_id) {
        return this._get('surveys/responses/anonymous', { external_id })
            .then(this._200SurveyResponse, this._404Null)
    }

    getReport(template, questions, from_date, through_date){
        return this._get('surveys/report/admin', {template, questions, from_date, through_date})
            .then(response => new SurveyQuestionResponses(response), this._404Null);
    }

    getAverageStarRating(question, from_date, through_date) {
        return this._get('surveys/report/average-star-rating', {question, from_date, through_date});
    }
    getFreeTextResponses(question, offset, limit, from_date, through_date) {
        return this._get('surveys/report/free-text', {question, offset, limit, from_date, through_date});
    }
}